import {createSelector} from "@reduxjs/toolkit";
import {IStore} from "modules/types";
import {MAX_VOTE_COUNT} from "modules/constants";
import {parseRequestState} from "modules/utils";

const getState = ({fanVoteReducer}: IStore) => fanVoteReducer;

export const getFanVotePlayerId = createSelector(getState, ({playerId}) => playerId);

export const getFanVoteHistory = createSelector(getState, ({history}) => history);

export const getFanVoteHasChanges = createSelector(getState, ({hasChanged}) => hasChanged);

export const getFanVoteCount = createSelector(getFanVoteHistory, (history) => history.length);

export const getIsAllVotePicked = createSelector(
	getFanVoteCount,
	(fanVoteCount) => fanVoteCount >= MAX_VOTE_COUNT
);

export const getFanVoteShareImage = createSelector(getState, (state) => state.shareImage);

export const getFanVoteShareImageRequestState = createSelector(getState, (state) =>
	parseRequestState(state.shareImageRequestState)
);

export const getIsLoadingFanVote = createSelector(
	getState,
	({fetchRequestState}) => !parseRequestState(fetchRequestState).isComplete
);
